import { toggleEntityVisualsForLineEditing } from '$lib/core/map/map-utils';
import type { SpanModel } from '$lib/models/ILineDataModel';
import type { CzmlDataSource, Entity } from 'cesium';

export type NewLinePath = {
    lat: number; 
    lng: number; 
    terrainPoint: string;
    mastId: null;
    selectedComponent: null;
} | {
    lat: number; 
    lng: number;
    terrainPoint: null;
    mastId: number;
    selectedComponent: string;
}

let selectedLine = $state<Entity | undefined>(undefined);
let selectedLineset = $state<SpanModel.ILineSetDataModel | undefined>(undefined)
let selectedSpan = $state<SpanModel.ILineSpanDataModel | undefined>(undefined);
let newLinePath = $state<NewLinePath[]>([]);

export let activeLineState = $state({
    selectedLine,
    selectedLineset,
    selectedSpan,
    newLinePath
})

export let getSelectedSpan = () => {
    return activeLineState.selectedSpan;
}

export let getSelectedLineset = () => {
    return activeLineState.selectedLineset;
}

export let setSelectedLineset = (lineset: SpanModel.ILineSetDataModel | undefined) => {
    activeLineState.selectedLineset = lineset;
}

export let setSelectedLine = (line: Entity | undefined) => {
    const prevLine = activeLineState.selectedLine;
    const newLine = line;
    // Handle side effects of selecting a new line in Cesium, such as toggling visuals for line editing
    // Unmark previous line if it exists
    if(prevLine){
        toggleEntityVisualsForLineEditing(
            [prevLine],
            false,
            prevLine.entityCollection.owner as CzmlDataSource
        );
    }
    // Mark new line if defined
    if(newLine){
        toggleEntityVisualsForLineEditing(
            [newLine],
            true,
            newLine.entityCollection.owner as CzmlDataSource
        );
    }
    activeLineState.selectedLine = line;
}

export let getNewLinePath = () => {
    return activeLineState.newLinePath;
}

export const setNewLinePath = (newPath: NewLinePath[]) => {
    activeLineState.newLinePath = newPath;
}
export const clearLineContext = () => {
    setSelectedLine(undefined);
    setSelectedLineset(undefined);
    activeLineState.selectedSpan = undefined;
    setNewLinePath([]);
}